const DEFAULT_INTERVAL_MS = 2500

function wait(milliseconds) {
  return new Promise((resolve) => window.setTimeout(resolve, milliseconds))
}

function csrfToken() {
  const element = document.querySelector("meta[name='csrf-token']")
  return element ? element.content : ""
}

async function responsePayload(response) {
  try {
    return await response.json()
  } catch (_error) {
    return {}
  }
}

export async function sendEmailQueue({
  form,
  recipientIds,
  formEntries = Array.from(new FormData(form).entries()),
  intervalMs = DEFAULT_INTERVAL_MS,
  cancelled = () => false,
  onStart = () => {},
  onResult = () => {}
}) {
  let lastStartedAt = 0

  for (let index = 0; index < recipientIds.length; index += 1) {
    if (cancelled()) break

    const delay = Math.max(0, intervalMs - (Date.now() - lastStartedAt))
    if (delay > 0) await wait(delay)
    if (cancelled()) break

    const recipientId = recipientIds[index]
    const body = new FormData()
    formEntries.forEach(([name, value]) => {
      if (name !== "user_ids[]") body.append(name, value)
    })
    body.append("user_ids[]", recipientId)
    lastStartedAt = Date.now()
    onStart({ recipientId, index: index + 1, total: recipientIds.length })

    try {
      const response = await fetch(form.action, {
        method: (form.method || "post").toUpperCase(),
        body,
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken(),
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      const payload = await responsePayload(response)

      if (!response.ok) {
        const status = payload.status === "failed" ? "failed" : "unknown"
        onResult({ recipientId, status, message: payload.error || `Request failed with ${response.status}`, payload })
      } else {
        onResult({ recipientId, status: payload.status || "unknown", message: payload.message, payload })
      }
    } catch (error) {
      onResult({ recipientId, status: "unknown", message: error.message })
    }
  }
}
